<template>
  <div class="exam">
    <div class="count">
      <div v-if="examPassState == 'passed' && parent=='jineng' && voiceBadge "><img class="textimg" src="http://res.study.itaojin.cn/2020-11/7d643a6946e548d3b20c87b45516875b.png" alt=""></div>
      <p>
        <!-- <span class="result-txt" v-if="examPassState == 'passed'">恭喜您已通过考试</span> -->
          <div class="result-txt result-text" v-if="examPassState == 'passed'  && parent!='jineng' &&  newPeopleBadge ">你已通过该课程的学习与考试!</div>
           <div class="result-txt result-text" v-if="examPassState == 'passed'  && parent=='jineng' && voiceBadge ">你已通过技能提升，现在可以去领任务了</div>

           <div class="result-txt result-text" v-if="examPassState == 'passed' && isexamination==false ">你已通过该课程！</div>
        <span class="result-txt" v-if="examPassState == 'failed'">很遗憾您未通过考试</span>
      </p>
      <div class="score-box" v-if="examPassState == 'failed'">
        <span>测试分数：<span class="num">{{ score }}分</span></span>
        <span>剩余测试机会：<span class="num">{{ remainingExamTimes }}次</span></span>
      </div>
      <div class="btn-box" v-if="examPassState == 'failed' || isexamination==false ">
        <span @click="returnCourseList" class="relearn_button">点击重新学习</span>
        <span @click="beginExam">再测一次</span>

      </div>
      <!-- 语音上岗 -->
      <div class="btn-box" v-if="examPassState == 'passed' && parent=='jineng' && voiceBadge">
        <span  @click="returnscene" >返回到场景</span>

        <!-- <span @click="returnCourseList">继续学习</span> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      examPassState: this.$route.query.state, //测试结果
      score: this.$route.query.score, //分数
      remainingExamTimes: this.$route.query.times, //剩余测试次数
      type: this.$route.query.type, //上级tab类型
      majorId: this.$route.query.majorId, //技能提升-场景-课程id
      tabMajorId: this.$route.query.tabMajorId, //tab的id
      courseId: this.$route.query.courseId, //课程id
      passScore: this.$route.query.passScore, //通关分数
      parent: this.$route.query.parent, //父级
      id: this.$route.query.id, //技能提升-场景id
      show: this.$route.query.show, //技能提升-场次和场景列表切换标识
      registration:0,   //判断是否报名
      voiceBadge:null, //语音上岗徽章
      newPeopleBadge:null, //语音新人徽章
      isPost:false,    //判断是否有上岗徽章
      isexamination:true,  //判断是否是考试页面
      isidNum:1 //判断几次进页面
    }
  },
 created(){
   this.registration=localStorage.getItem("registration")
   console.log(this.registration,63)
   this.parent=this.$route.query.parent
   console.log(this.parent,'我在')
console.log(this.$route.query.state,'穿过看来')
console.log(this.$route.query.score, '分数')
    this.getTrainList()
 },
 beforeMount:function(){
    if(localStorage.getItem('badgeUrl')=='false'){this.badgeUrl=false}
 },
  mounted: function() {

  },
  methods: {
    //语音上岗徽章点击跳转到场景
    returnscene(){
      localStorage.setItem('trainState','no')
      window.location.href = '/tjkStudy/train/index?type=SkillUpgrade'+'&tabMajorId='+this.tabMajorId+'&show=no';

    },
    // 查看是否报名
      getTrainList() {
      var self = this;
      this.$http.post(API_ROOT.college + "/preWorkTrain/customer/queryBadgeByCourseId", {
          "courseId" :this.courseId,
          "businessMajorId" :isNaN(self.id)== false ? self.id : null//结业考试会传，任务指南考试不传
        })
        .then(
          (res) => {
       
            var result = res.data;
                console.log(result.data!=null,999)
            if(result.data!=null){
              this.isexamination=true
              if(result.data.newPeopleBadge){
                self.newPeopleBadge = result.data.newPeopleBadge
                // console.log(this.newPeopleBadge,8858)
            }
            if(result.data.voiceBadge){
                self.voiceBadge = result.data.voiceBadge
            }

            }else{
            this.isexamination=false
            }
          },
          (res) => {
            this.$alert(
              "AJAX请求接口异常（/preWorkTrain/customer/queryTrainListWeb）！"
            );
          }
        );
    },
    // 去报名
    Gosignup(){
        this.$http.post(API_ROOT.college + "/preWorkTrain/customer/applyTrainPreCondition",null) .then((res) => {
              var result = res.data;
              if(result.data == null){
                  if(this.examPassState == 'passed' && this.registration== 0){
                      localStorage.setItem('trainState','no')
                      window.location.href = '/tjkStudy/train/index?type=SkillUpgrade'+'&tabMajorId='+this.tabMajorId+'&show=yes';
                  }else{
                      window.location.href = '/tjkStudy/train/index?type=SkillUpgrade'+'&tabMajorId='+this.tabMajorId+'&show=yes';
                  }
              }else{
                  this.$alert(result.data);
              }
          },(res) => {
              this.$alert("AJAX请求接口异常（/preWorkTrain/customer/applyTrainPreCondition）！");
          }
        );
    },
    //重新学习
    returnCourseList() {
    
      
          this.id=localStorage.getItem('id')
          this.majorId=localStorage.getItem('majorId')
          window.location.href = '/tjkStudy/train/childCourseList?id='+this.id+'&type='+this.type+'&majorId='+this.majorId+'&tabMajorId='+this.tabMajorId+'&show='+this.show;
    },
    beginExam() {
      window.location.href = '/tjkStudy/train/examDetail?courseId='+this.courseId+'&tabMajorId='+this.tabMajorId+'&type='+this.type+'&score='+this.passScore+'&parent='+this.parent;
    }
  }
}
</script>

<style lang="less" scoped>
  .count {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
    > p {
      font-size: 30px;
      padding: 20px 0;
    }
  }
  .score-box {
    margin: 10px 0;
    span {
      color: #666666;
      font-size: 16px;
      line-height: 30px;
      margin-right: 20px;
      &.num {
        font-weight: bold;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .btn-box {
    margin-top: 30px;
    > span {
      background: #497AF2;
      border-radius: 6px;
      color: #fff;
      width: 152px;
      text-align: center;
      cursor: pointer;
      display: inline-block;
      padding: 10px 20px;
      font-size: 16px;
      line-height: 20px;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
    
  }
  .textimg{width: 20vw;}
  .result-text{color: #000;font-weight: 500;font-size: 18px;}
  .btn-box>span{border-radius:20px !important;}
  .relearn_button{
    background-color:#d3d5d7 !important;color: #898a8c !important;}
    
</style>


// WEBPACK FOOTER //
// ./src/page/train/examResult.vue